import React from "react";
import PropTypes from "prop-types";

import loaderGif from "../assets/images/loader-transparent.svg";

const Loader = props => (
  <div className="loader-container-fixed">
    <img src={loaderGif} alt="loading" />
    <p>{props.text}</p>
  </div>
);

export default Loader;

Loader.defaultProps = {
  text: ""
};

Loader.prototype = {
  text: PropTypes.string
};
